var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center h-70 d-flex align-items-center justify-content-center"},[_c('b-spinner',{staticClass:"m-5 spinner-main",attrs:{"label":"Loading...","variant":"dark"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }